import BannerComponent from './banner.component'

const BannerModule = angular.module('cdbl.banner', [

])
  .component('cdblBanner', BannerComponent)
  .name

export default BannerModule
